export default {
    loadingContainer: {},
    loaderSvg: {},
    descriptionText: {
        fontSize: '14px',
        '@media (min-width: 601px)': {
            fontSize: '16px'
        }
    },
    defaultStyle: {
        overflow: 'auto',
        font: data => '16px ' + data.fontFamily1,
        background: 'rgba(0, 0, 0, 0.5)',
        position: 'fixed',
        left: '0',
        top: '0',
        right: '0',
        bottom: '0',
        zIndex: '200'
    },
    loadingWrapper: {
        display: 'table',
        height: '100%',
        width: '100%',
        '& $loadingContainer': {
            background: '#fff',
            display: 'table-cell',
            verticalAlign: 'middle',
            textAlign: 'center',
            padding: '20px',

            '@media (min-width: 601px)': {
                padding: '50px'
            }
        }
    },
    '@keyframes rotateInfinite': {
        from: {transform: 'rotate(0deg)'},
        to: {transform: 'rotate(359deg)'}
    },
    loadingSvg: {
        fill:data=>data.mainColor,
        textAlign: 'center',
        display: 'block',
        margin: '0 auto',
        marginBottom: '20px',
        height: '35px',
        backgroundSize: 'contain',
        background: 'no-repeat center',
        animation: '$rotateInfinite 2s infinite linear',
        '& .cls-1':{opacity:0.2},
        '& .cls-2':{opacity:0.8},
        '& .cls-3':{opacity:0.1},
        '& .cls-4':{opacity:0.7},
        '& .cls-5':{opacity:0.05},
        '& .cls-6':{opacity:0.6},
        '& .cls-7':{opacity:0.03},
        '& .cls-8':{opacity:0.5},
        '& .cls-10':{opacity:0.4},
        '& .cls-11':{opacity:0.9},
        '& .cls-12':{opacity:0.3}
    }
};
